import { UserMinus } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";
import type { IDashboardAccessRevokedCardProps } from "./types";

// NOTE: NSAI-6940 — no CTA, like the chat and assistant removal cards: the
// dashboard is exactly what the reader can no longer open.
const DashboardAccessRevokedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IDashboardAccessRevokedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="dashboard_access_revoked"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserMinus className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.dashboard_access_revoked.body", {
        ownerName: data.ownerName,
        dashboardName: data.dashboardName,
      })}
    />
  );
};

export const DashboardAccessRevokedCard = memo(
  DashboardAccessRevokedCardComponent,
);
